

























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import Tracker from '@/components/Tracker.vue'
import { Slide } from '../../@types/Slide'
import Visualization from '../../mixins/Visualization.vue'

@Component
export default class TrackerVisualization extends Mixins(
  Tracker,
  Visualization
) {
  @Prop() public slides!: Slide[]

  /**
   * Slides in the presentation
   */
  get slidesInPresentation() {
    if ((this.$parent as any).presentationPath) {
      return (this.$parent as any).presentationPath.map(indexes => {
        const slide = JSON.parse(
          JSON.stringify(indexes.reduce((s, i) => s.slides[i - 1], this))
        )
        return slide
      })
    }
  }

  get filteredSlidesInPresentation() {
    return this.slidesInPresentation.filter((slide, index) => {
      return this.options.filterOut
        ? !this.options.filterOut.includes(index + 1)
        : true
    })
  }

  /**
   * Groups.
   */
  get groups() {
    //@ts-ignore
    return this.options.groupBy
      ? this.filteredSlidesInPresentation.reduce((a, c, i) => {
          //@ts-ignore
          const group = Object.entries(this.options.groupBy).find(([k, v]) =>
            //@ts-ignore
            v.includes(i + 1)
          )

          if (group) {
            a[group[0]] = a[group[0]] || []
            a[group[0]].push(c)
          }

          return a
        }, {})
      : this.filteredSlidesInPresentation
  }

  /**
   * Get index of slide.
   */
  public getSlideIndex(slide) {
    return this.slidesInPresentation.indexOf(slide) + 1
  }

  /**
   * Get path for index.
   */
  public getPathForIndex(index) {
    const path = (this.$parent as any).presentationPath[index - 1].join('/')
    const project = path ? '' : `/${this.$route.params.project}`

    return `${project}${path}`
  }
}
